import { ClassSansProvider, FactorySansProvider, InjectionToken, Type } from '@angular/core';
import { EnvironmentName } from '../shared/config';
import { getEnvironmentName } from '../shared/utils/env-utils';
import { IFHIRService } from './fhir-service.interface';
import { FHIRService } from './fhir.service';
import { StandaloneService } from './standalone.service';

export const FHIRServiceInjectionToken = new InjectionToken<IFHIRService>('IFHIRService');

export interface FHIRServiceUseClass extends ClassSansProvider {
  useClass: Type<IFHIRService>;
}

export interface FHIRServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => IFHIRService;
}

export type FHIRServiceProvider = FHIRServiceUseFactory | FHIRServiceUseClass;

export function provideAuthService() {
  const useClass =
    getEnvironmentName() === EnvironmentName.STANDALONE ? StandaloneService : FHIRService;

  return {
    provide: FHIRServiceInjectionToken,
    useClass,
  };
}
